module.exports = __webpack_public_path__ + "static/media/banner_03.b1235d7b.png";